import store from "../store";
import { refreshToken } from "../store/actions/auth.action";
import axios from "./axios.instance";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const setup = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = window.localStorage.getItem("accessToken");
      if (token) {
        config.headers["accessToken"] = token;
        // config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry &&
        originalRequest.url !== "auth/login" &&
        originalRequest.url !== "auth/token"
      ) {
        console.log('interceptor')
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers["Authorization"] = `Bearer ${token}`;
              return axios(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }

        originalRequest._retry = true;
        isRefreshing = true;

        const refreshTokenStorage = window.localStorage.getItem("refreshToken");
        return new Promise((resolve, reject) => {
          if (refreshTokenStorage) {
            store
              .dispatch(refreshToken(refreshTokenStorage))
              .then((data) => {
                window.localStorage.setItem("accessToken", data?.token);
                processQueue(null, data?.token);
                originalRequest.headers["accessToken"] = data?.token;
                // originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
                resolve(axios(originalRequest));
              })
              .catch((err) => {
                processQueue(err, null);
                reject(err);
              })
              .finally(() => {
                isRefreshing = false;
              });
          } else {
            reject(error);
          }
        });
      }

      return Promise.reject(error);
    }
  );
};

export default setup;
